/*
 * @Author: cloud
 * @Date: 2020-12-28 10:34:39
 * @Last Modified by: cloud
 * @Last Modified time: 2021-04-13 10:37:46
 */

import eventBus from "@/utils/eventBus.js"
import router from "@/router"
import axios from "axios"
// import { appLogin } from './jsbridge'
// import { getCookie } from './cookie'
// import { Toast, Loading } from 'vue-ydui/dist/lib.rem/dialog';
// 创建axios实例
// import Cookies from 'js-cookie'
const redirectLogin = () => {
  // const forword = window.location.href.split("#")[1]
  // if (forword != '/' && forword.indexOf("login") === -1) {
  //   // 防止重复跳转到登录页面
  //   router.replace({
  //     path: "/login",
  //     query: {
  //       forword: forword
  //     }
  //   })
  // 从页面登录修改为弹窗登录
  const forword = window.location.href.split("#")[1]
  if (forword != '/' && forword.indexOf("loginNew") === -1) {
    eventBus.$emit('doChangeloginVisible', true)
    localStorage.setItem("token", "")
    eventBus.$emit("outLogin", 2)
  }
}

window._apiUrls = window._apiUrls || {}
let protocol = window.location.protocol
let redirectHost=protocol+'//'+window.location.host+'/api-biz'
window.__baseUrl__ =
  process.env.NODE_ENV == "production"
    ? redirectHost
    : process.env.NODE_ENV == "test"
      ? redirectHost
      : process.env.NODE_ENV == "test2"
        ? redirectHost
        : window._apiUrls.dev

const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_URL, // api 的 base_url
  baseURL: window.__baseUrl__,

  // timeout: 15000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
  config => {
    // if (config.token) {
    let token = localStorage.getItem("token")

    // if (!token) {
    //   redirectLogin()
    // }
    if (token) {
      config.headers.Authorization = token
    }
    // config.headers.Authorization = token;
    // }
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(
  response => {
    console.log(response)
    if (response.data.code === 401 && (typeof response.config.params === 'undefined' || typeof response.config.params.noopenlogin === 'undefined' || !response.config.params.noopenlogin)) {
      redirectLogin()
    }
    // if (response.data.code === 501) {//购买会员
    //   eventBus.$emit("changeBuy", true)
    // }
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    if (response.config.headers.retheader) {
      return response
    } else {
      return response.data
    }

  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js